import { ICONE_CONCORRENTE_PADRAO } from '../constants/concorrente.constants';

export function resolverIdentidadeConcorrente(concorrente: {
  imagemUrl?: string | null;
  icone?: string | null;
}): { tipo: 'imagem' | 'icone'; valor: string } {
  if (concorrente.imagemUrl) {
    return { tipo: 'imagem', valor: concorrente.imagemUrl };
  }

  if (concorrente.icone) {
    return { tipo: 'icone', valor: concorrente.icone };
  }

  return { tipo: 'icone', valor: ICONE_CONCORRENTE_PADRAO };
}
